/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      helper — `(ui-is-nuova)`: true when this device renders the
 *              «UI nuova» (service:ui enabled by instance-initializers/ui.js,
 *              the preview gate passed, stored version 'nuova')
 *   extends:   Helper (@ember/component/helper)
 *   template:  none
 *   uses:      service:ui (beebee-base, optional lookup)
 *   siblings:  beebee-base-template helpers/ui-is-nuova.js (same helper for the
 *              apps on the shared shell; this app does not depend on
 *              beebee-base-template), templates/index.hbs (the fork),
 *              components/booking-index-nuova.hbs
 *   tests:     booking-index-nuova-test.js
 *   gotchas:   the index controller is a frozen god-file (size ratchet), so the
 *              fork reads the switch through this helper instead of a
 *              `@service ui` on the controller.
 *
 * Plan: docs/ui-nuova/MIGRATION-PLAN.md §1.2 (template switch), step M9 booking.
 */
import Helper from '@ember/component/helper';
import { getOwner } from '@ember/application';

export default class UiIsNuovaHelper extends Helper {
  // `ui.isNuova` is tracked (version, enabled, unlocked, tenant): reading it here
  // re-runs compute when the gate changes, e.g. when routes/application.js pushes
  // the tenant of the public page.
  compute() {
    return Boolean(getOwner(this)?.lookup('service:ui')?.isNuova);
  }
}
